import * as resourceService from '../services/resource';

export default function(adults, children, infants) {
    let result = '';

    if (adults) {
        const adultString = adults > 1 ? 'ADULTS' : 'ADULT';
        result = `${adults} ${resourceService.get(adultString).toLowerCase()}`;
    }

    if (children) {
        const childString = children > 1 ? 'CHILDREN' : 'CHILD';
        result = `${result}, ${children} ${resourceService.get(childString).toLowerCase()}`;
    }

    if (infants) {
        const infantString = infants > 1 ? 'INFANTS' : 'INFANT';
        result = `${result}, ${infants} ${resourceService.get(infantString).toLowerCase()}`;
    }

    return result;
}
